// extracted by mini-css-extract-plugin
export var aptitudeViewer = "AptitudeViewer-module--aptitudeViewer--3mpsf";
export var skipAptitudeCtaContainer = "AptitudeViewer-module--skipAptitudeCtaContainer--33WPR";
export var skipAptitudeCta = "AptitudeViewer-module--skipAptitudeCta--1jnb9";
export var activeContentSwitcher = "AptitudeViewer-module--activeContentSwitcher--1qGif";
export var embed = "AptitudeViewer-module--embed--1c1k6";
export var ctaContainer = "AptitudeViewer-module--ctaContainer--pTIYu";
export var postAptitudeCta = "AptitudeViewer-module--postAptitudeCta--2ihDk";